import React from "react";

import FeedbackHeader from "../../layout/FeedbackHeader";
import FeedbackRating from "../Input/FeedbackRating";
import { ErrorMessage } from "./ErrorMessage";
import { FeedbackFormLayout } from "../../layout/FeedbackFormLayout";

export const Question1CoachingMethodology = ({
  coachingMethodologyRating,
  updateRatingFormData,
  validationError,
}) => {
  return (
    <>
      <FeedbackFormLayout
        title={"Experience with the coaching methodology"}
        subtitle={
          "Tell us more about if and how the coaching steps and structure help you."
        }
      >
        <FeedbackHeader
          title={
            "How would you rate the effectiveness of the coaching methodology (e.g. techniques, styles) in helping you achieve your goals?*"
          }
        />
        <FeedbackRating
          inputID={"coachingMethodologyRating"}
          rating={coachingMethodologyRating}
          updateRatingFormData={updateRatingFormData}
        />
        {validationError?.error && (<ErrorMessage text={validationError.error} />)}
      </FeedbackFormLayout>
    </>
  );
};
